module.exports = __webpack_public_path__ + "static/media/Retreats-05.b794fbae.webp";